import React, { useRef } from 'react';
import { InputSmall, Input } from '../../../styles/styleUtils';

const formatarMoeda = (valor) => {
  if (Number.isNaN(valor)) valor = 0;
  return (valor || 0).toLocaleString('pt-BR', {
    style: 'currency',
    currency: 'BRL',
  });
};

const limparValor = (valor) => {
  const apenasNumeros = valor.replace(/\D/g, '');
  return Number(apenasNumeros) / 100;
};

const CampoMonetario = ({ valor, onChange, name, type, disabled }) => {
  const inputRef = useRef(null);

  const handleChange = (e) => {
    const valorNumerico = limparValor(e.target.value);
    onChange({ target: { name, value: valorNumerico } });
  };

  const handleFocus = () => {
    // Mantém o cursor no final
    setTimeout(() => {
      const input = inputRef.current;
      if (input) {
        const len = input.value.length;
        input.setSelectionRange(len, len);
      }
    }, 0);
  };

  return type === 'Half' ? (
    <Input
      type="text"
      inputMode="numeric"
      ref={inputRef}
      value={formatarMoeda(valor)}
      onChange={handleChange}
      onFocus={handleFocus}
      disabled={disabled}
    />
  ) : (
    <InputSmall
      type="text"
      inputMode="numeric"
      ref={inputRef}
      value={formatarMoeda(valor)}
      onChange={handleChange}
      onFocus={handleFocus}
      disabled={disabled}
    />
  );
};

export default CampoMonetario;
